import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getQuizQuestions } from "../../../api/endpoints/QuizEndpoints";
import { Paged } from "../../../models/Paged";
import { Question } from "../../../models/Question";

export default function useGetQuestionsPaginated(quizzId: number) {
  return useMutation<Paged<Question>, AxiosError, { page: number }>({
    mutationKey: ["questions"],
    mutationFn: ({ page }) => getQuizQuestions(quizzId, page),
  });
}
